<template>
  <div class="content-body" style="padding-top: 6rem">
    <div class="container-fluid">
      <div class="page-titles">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="javascript:void(0)">Slider</a>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'Slider Testimoni Home' }"
              >Data Slider Testimoni Home</router-link
            >
          </li>
          <li class="breadcrumb-item">
            <a href="javascript:void(0)">{{ currentRouteName }}</a>
          </li>
        </ol>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Form {{ currentRouteName }}</h4>
            </div>
            <div class="card-body">
              <div class="basic-form">
                <!-- Nama -->
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Nama</label>
                  <div class="col-sm-9">
                    <input
                      v-model="post.nama"
                      @input="generateSlug"
                      type="text"
                      class="form-control"
                      placeholder="Masukkan Nama"
                      required
                    />
                  </div>
                </div>

                <!-- Slug -->
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Slug URL</label>
                  <div class="col-sm-9">
                    <input
                      v-model="post.slug"
                      type="text"
                      class="form-control"
                      placeholder="Slug URL (Otomatis)"
                      readonly
                    />
                  </div>
                </div>

                <!-- Kategori (Auto / Fixed) -->
                <!-- <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Kategori</label>
                  <div class="col-sm-9">
                    <input
                      type="text"
                      class="form-control"
                      value="Slider Apa kata mereka"
                      readonly
                    />
                  </div>
                </div> -->

                <!-- Photo (Kotak) -->
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label"
                    >Photo (Ukuran Kotak 1:1)</label
                  >
                  <div class="col-sm-9">
                    <div class="custom-file mb-2">
                      <input
                        type="file"
                        id="photo"
                        @change="handleFileUpload"
                        class="custom-file-input"
                        accept="image/*"
                        required
                      />
                      <label class="custom-file-label" for="photo">{{
                        post.image ? post.image.name : "Pilih foto"
                      }}</label>
                    </div>
                    <!-- Photo Preview Box (Kotak 1:1) -->
                    <div v-if="imagePreview" class="mt-3">
                      <p class="text-muted mb-1" style="font-size: 12px">
                        Pratinjau Foto Kotak:
                      </p>
                      <div
                        class="square-preview-container"
                        style="
                          width: 130px;
                          height: 130px;
                          border: 2px dashed #007bff;
                          border-radius: 12px;
                          overflow: hidden;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          background: #fff;
                          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                        "
                      >
                        <img
                          :src="imagePreview"
                          alt="Photo Preview"
                          style="
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            aspect-ratio: 1 / 1;
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Company -->
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Perusahaan</label>
                  <div class="col-sm-9">
                    <input
                      v-model="post.nama_perusahaan"
                      type="text"
                      class="form-control"
                      placeholder="Masukkan Perusahaan / Company"
                    />
                  </div>
                </div>

                <!-- Deskripsi -->
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Deskripsi</label>
                  <div class="col-sm-9">
                    <textarea
                      ref="summernote"
                      id="deskripsi"
                      v-model="post.deskripsi"
                      class="form-control summernote"
                      rows="4"
                      placeholder="Masukkan Deskripsi Testimoni"
                    ></textarea>
                  </div>
                </div>

                <!-- Publish Status -->
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Publish Status</label>
                  <div class="col-sm-9">
                    <select
                      v-model="post.is_publish"
                      class="form-control"
                      required
                    >
                      <option value="">Pilih Status</option>
                      <option value="true">Publish</option>
                      <option value="false">Unpublish</option>
                    </select>
                  </div>
                </div>

                <!-- Buttons -->
                <div class="form-group row">
                  <div class="col-sm-9 offset-sm-3">
                    <button
                      type="button"
                      @click="goBack"
                      class="btn btn-warning btn-sm mr-2"
                    >
                      Kembali
                    </button>
                    <button
                      type="button"
                      @click="submitPost"
                      class="btn btn-primary btn-sm"
                    >
                      Simpan
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import Swal from "sweetalert2";
import axiosInstance from "../../../axios";

export default {
  name: "Tambah Slider Testimoni Home",
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const summernote = ref(null);
    const currentRouteName = computed(() => route.name);

    const post = ref({
      nama: "",
      slug: "",
      id_kategori: 11, // Auto set to ID 11 (Slider Apa kata mereka)
      image: null,
      nama_perusahaan: "",
      deskripsi: "",
      is_publish: "",
      user: null,
    });

    const imagePreview = ref(null);

    const isAuthenticated = computed(() => store.getters.isAuthenticated);
    const token = computed(() => store.getters.token);
    const tokenExpiry = computed(() => store.getters.tokenExpiry);

    if (
      !token.value ||
      !tokenExpiry.value ||
      new Date() > new Date(tokenExpiry.value) ||
      !isAuthenticated.value
    ) {
      Swal.fire({
        title: "Error",
        text: `Session expired or invalid`,
        icon: "error",
        confirmButtonText: "OK",
      }).then(() => {
        store.dispatch("setAuth", false);
        store.dispatch("setToken", { token: null, expiry: null });
        localStorage.clear();
        router.replace({ name: "Login" });
      });
      return;
    }

    const fetchUser = async () => {
      try {
        const response = await axiosInstance.get("/user", {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token.value}`,
          },
        });
        if (response.status === 200) {
          post.value.user = response.data.id;
        }
      } catch (error) {
        console.error("Failed to fetch user", error);
      }
    };

    const handleFileUpload = (event) => {
      const file = event.target.files[0];
      if (!file) return;

      const validTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/webp",
        "image/svg+xml",
      ];
      const maxSize = 2 * 1024 * 1024; // 2MB

      if (!validTypes.includes(file.type)) {
        Swal.fire({
          title: "Invalid File Type",
          text: "Pilih gambar format jpeg, jpg, png, webp, atau svg.",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      if (file.size > maxSize) {
        Swal.fire({
          title: "File Too Large",
          text: "Ukuran gambar tidak boleh lebih dari 2MB.",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      post.value.image = file;

      const reader = new FileReader();
      reader.onload = (e) => {
        imagePreview.value = e.target.result;
      };
      reader.readAsDataURL(file);
    };

    const generateSlug = () => {
      if (!post.value.nama) {
        post.value.slug = "";
        return;
      }
      post.value.slug = post.value.nama
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    };

    const goBack = () => {
      router.push({ name: "Slider Testimoni Home" });
    };

    const validateForm = () => {
      if (!post.value.nama) {
        Swal.fire("Validation Error", "Nama wajib diisi.", "error");
        return false;
      }
      if (!post.value.image) {
        Swal.fire("Validation Error", "Photo wajib diunggah.", "error");
        return false;
      }
      if (!post.value.is_publish) {
        Swal.fire("Validation Error", "Status Publish wajib dipilih.", "error");
        return false;
      }
      return true;
    };

    const submitPost = async () => {
      post.value.deskripsi = $("#deskripsi").summernote("code");
      if (!validateForm()) return;

      const formData = new FormData();
      formData.append("nama", post.value.nama);
      formData.append("slug", post.value.slug);
      formData.append("id_kategori", post.value.id_kategori);
      formData.append("nama_perusahaan", post.value.nama_perusahaan);
      formData.append("deskripsi", post.value.deskripsi);
      formData.append("is_publish", post.value.is_publish);
      if (post.value.user) {
        formData.append("user", post.value.user);
      }
      if (post.value.image) {
        formData.append("image", post.value.image);
      }

      try {
        const response = await axiosInstance.post("/testi", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token.value}`,
          },
        });

        if (response.status === 200 || response.status === 201) {
          Swal.fire({
            title: "Success",
            text: "Data Slider Testimoni Home berhasil disimpan!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            goBack();
          });
        } else {
          Swal.fire({
            title: "Error",
            text: "Gagal menyimpan data",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      } catch (error) {
        Swal.fire({
          title: "Error",
          text: `Error: ${error.message}`,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    };

    onMounted(async () => {
      await fetchUser();
      await nextTick();
      $(summernote.value).summernote({
        height: 200,
        callbacks: {
          onChange: (contents) => {
            post.value.deskripsi = contents;
          },
        },
      });
    });

    return {
      currentRouteName,
      post,
      imagePreview,
      handleFileUpload,
      generateSlug,
      submitPost,
      goBack,
      summernote,
    };
  },
};
</script>

<style scoped>
.content-body {
  padding: 30px;
  background: #f4f4f9;
}
.square-preview-container {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}
select.form-control,
select.form-control option {
  background-color: #ffffff !important;
  color: #212529 !important;
}
</style>
